import CounterStyleField from '@admin/components/mjson_designer/components/counterstylefield'
import TextStyleField from '@admin/components/mjson_designer/components/textstylefield'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

class EditCountdownBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    parent: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    website: PropTypes.object,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, parent, theme, type, website } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Date)', name: 'content.date', type: 'datefield', required: true, placeholder: 'Enter date', value: config.content.date },
                { label: 't(Time)', name: 'content.time', type: 'timefield', required: true, placeholder: 'Enter time', value: config.content.time }
              ]
            },
            {
              label: 't(Options)',
              fields: [
                { label: 't(Show)', name: 'content.show', type: 'checkboxgroup', options: [
                  { value: 'days', text: 't(Days)' },
                  { value: 'hours', text: 't(Hours)' },
                  { value: 'minutes', text: 't(Minutes)' },
                  { value: 'seconds', text: 't(seconds)' }
                ], defaultValue: ['days','hours','minutes','seconds'], value: config.content.show }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Countdown)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Counter)', name: 'styles.counter', device, collapsing: true, collapsed: true, type: CounterStyleField, theme, defaultValue: {
                  margin: '10px'
                }, value: config.styles.counter },
                { label: 't(Quanity Text Style)', name: 'styles.quantityText', collapsing: true, collapsed: true, type: TextStyleField, device, theme, defaultValue: {
                  preset: 'heading_large',
                  color: {
                    value: 'default'
                  },
                  align: 'center'
                }, value: config.styles.quantityText },
                { label: 't(Units Text Style)', name: 'styles.unitsText', collapsing: true, collapsed: true, type: TextStyleField, device, theme, defaultValue: {
                  preset: 'text',
                  color: {
                    value: 'default'
                  },
                  align: 'center'
                }, value: config.styles.unitsText },
                { label: 't(Alignment)', name: 'styles.align', collapsing: true, collapsed: true, type: 'alignmentfield', defaultValue: 'left', value: config.styles.align }
              ]
            },
            ...styles.getIsFlexChild(parent) ? [
              styles.FlexChildSection(config, device, theme, website, type)
            ] : [],
            styles.BackgroundSection(config, device, theme, website, type),
            styles.BoxShadowSection(config, device, theme, website, type),
            styles.BorderSection(config, device, theme, website, type),
            styles.SizingSection(config, device, theme, website, type, true, true),
            styles.SpacingSection(config, device, theme, website, type),
            styles.TransformSection(config, device, theme, website, type),
            styles.AnimationSection(config, device, theme, website, type),
            styles.FiltersSection(config, device, theme, website, type),
            styles.OverflowSection(config, device, theme, website, type),
            styles.VisibilitySection(config, device, theme, website, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditCountdownBlock
